export function getHeight(el: Element | null, multiplier = 1): number {
  if (!el) return 0
  return el.getBoundingClientRect().height * multiplier
}
